import axios from "axios";
import { RfidTypes } from "../component/rfidCard/RfidCardTypes";

const RfidCardActions = () => {
  const baseUrl = ``;

  const getRfidCard = async (tenant: string, params: any) => {
    return await axios.get(`${baseUrl}/masterdatavehicle/rfidcard`, {
      params: { tenant, ...params },
    });
  };

  const exportAllRfidCardData = async (params: any) => {
    return await axios.get(`${baseUrl}/masterdatavehicle/rfidcard/excel`, {
      params: params,
      responseType: "arraybuffer",
      headers: { "Access-Control-Allow-Origin": true },
    });
  };
  const uploadRfidCardFile = async (
    tenant: string,
    languageTag: string,
    file: FormData
  ) => {
    return await axios.post(
      `${baseUrl}/masterdatavehicle/rfidcardimporttracking/file`,
      file,
      {
        params: {
          tenant: tenant,
          languageTag: !!languageTag ? languageTag : null,
        },
      }
    );
  };

  const createRfidCard = async (
    tenant: string,
    languageTag: string,
    createData: RfidTypes.CreateModal
  ) => {
    return await axios.post(
      `${baseUrl}/masterdatavehicle/rfidcard`,
      createData,
      {
        params: { tenant: tenant, languageTag: languageTag },
      }
    );
  };

  const downloadTemplate = async () => {
    return axios.get("masterdatavehicle/rfidcardimporttracking/template", {
      responseType: "arraybuffer",
      headers: { "Access-Control-Allow-Origin": true },
    });
  };

  return {
    getRfidCard,
    exportAllRfidCardData,
    uploadRfidCardFile,
    createRfidCard,
    downloadTemplate,
  };
};

export default RfidCardActions;
